import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { SEOHead } from '../components/SEOHead';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Newspaper, Calendar, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// « Actualités » page inside every user account: published blog articles (AI-written, admin-validated)
const DashboardNewsPage = () => {
  const [posts, setPosts] = useState([]);
  const [tag, setTag] = useState('');
  useEffect(() => { axios.get(`${API}/blog`, { params: tag ? { tag } : {} }).then((r) => setPosts(r.data)).catch(() => {}); }, [tag]);
  const tags = [...new Set(posts.flatMap((p) => p.tags || []))].slice(0, 12);

  return (
    <div className="min-h-screen bg-[#F9FAFB] py-8">
      <SEOHead title="Actualités du bâtiment" description="Actualités, matériaux, matériel et réglementation du bâtiment en Belgique." path="/dashboard/actualites" noindex />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading font-bold text-3xl text-[#111827] flex items-center gap-2" data-testid="dashboard-news-title"><Newspaper className="w-7 h-7 text-[#1E3A8A]" /> Actualités du bâtiment</h1>
        <p className="text-[#6B7280] mt-1">Réglementation, nouveaux matériaux, matériel et marchés : les articles validés par l'équipe BuildConnect.</p>
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4">
            <button type="button" onClick={() => setTag('')} className={`text-xs px-3 py-1 rounded-full border ${!tag ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]' : 'bg-white text-[#374151]'}`}>Tous</button>
            {tags.map((t) => <button key={t} type="button" onClick={() => setTag(t)} className={`text-xs px-3 py-1 rounded-full border ${tag === t ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]' : 'bg-white text-[#374151]'}`}>{t}</button>)}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-testid="dashboard-news-list">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`news-card-${p.slug}`}><Card className="card-surface h-full"><CardContent className="p-6">
              <div className="flex flex-wrap gap-1 mb-2">{(p.tags || []).map((t) => <Badge key={t} className="badge-trade text-xs">{t}</Badge>)}</div>
              <h2 className="font-heading font-bold text-lg text-[#111827]">{p.title}</h2>
              <p className="text-sm text-[#4B5563] mt-2 line-clamp-3">{p.excerpt}</p>
              <p className="text-xs text-[#9CA3AF] mt-3 flex items-center justify-between"><span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {p.published_at ? new Date(p.published_at).toLocaleDateString('fr-BE') : ''}</span><span className="flex items-center gap-1 text-[#1E3A8A]">Lire <ArrowRight className="w-3 h-3" /></span></p>
            </CardContent></Card></Link>
          ))}
          {posts.length === 0 && <p className="text-[#6B7280]">Aucun article pour le moment.</p>}
        </div>
      </div>
    </div>
  );
};

export default DashboardNewsPage;
